import { gql } from '@apollo/client'

export default gql(`
subscription{
    publishRuleUpdated{
        id
        assetId
        group{
          id
        }
        isEnabled
        publishEndDate
        publishStartDate
      }
  }`)
